export const requireLogin = (to, from, next) => {
  const { auth, loggedIn } = to.meta;
  if (auth && !loggedIn) {
    next.redirect('/login');
  } else {
    next();
  }
};

export const requireRole = role => (to, from, next) => {
  const { current } = to.meta;
  if (!current.roles.find(({ name }) => name === role)) {
    next.redirect('/home');
  } else {
    next();
  }
};
